/* eslint-disable unused-imports/no-unused-vars */
import axios from '@axios'

export default {
    namespaced: true,
    state: {
        camposATSventas: [],
        camposForm107: [],
        camposATS: [],
        camposImportATS: [],
        ficha: [],
        fichaXML: [],
        ficha_completa: [],
        discapacidad: [],
        variables: [],
        impuestoRenta: [],
        documentos: [],
        exportExcel: [],
        SRI: [],
        a16470: [],
        a16475: [],
        a16475_datos: [],
        a06t5: [],
        deducciones: [],
        divisionesUser: [],
        divisionesAll: [],
        form107: [],
        form103: [],
        resumen103: [],
        current_page: 1,
        last_page: 0,
        per_page: 0,
        total: 0,
        informe: [],
        resumido: [],
        resumDiv: [],
        a16475Detalle: [],
        a16475DetalleTabla: [],
        descargaFormato: '',
        a16475_datos_SinCalc: [],
        a16475_datos_SinCalcEx: [],
        total_SinCalc: [],
        form107_SinCalc: [],
        a16475DetalleTabla_SinCalc: [],
        resumido_SinCalc: [],
        resumDiv_SinCalc: [],
        codigosReten: [],
        codigos104_sustentos: [],
        proveedor: [],
        identificaciones: [],
        IVA_ATS: [],
        ICE_ATS: [],
        RetIVA: [],
        colaboradores: [],
        codigoTransaccion: [],
        CodigoIdentificacion: [],
        RelacionTransaccionIdentificacion: [],

        DatosConceptosAIR: [],
        EliminarConceptoRetencion: [],

        TipoComprobante: [],
        RelacionComprobanteTransaccion: [],
        RelacionComprobanteSustento: [],
        SustentoTributario: [],
        DatosTipoComprobante: [],

        //variables CODIGO REGIMEN
        CodigosRegimen: [],
        EliminarCodigoRegimen: [],
        ruc: [],
        datosContribuyenteProv: [],

        divisionesUserATS: [],

        //DG
        divisionesUserCS: [],
        reporteComprasServicios: [],

        proveedoresATS: [],
        colaboradoresATS: [],
        Usuarios: [],
        DivisionesGeneral: [],
        controlErroresUsuario: [],
        CierreSRI: [],
        tipoPaises: [],
        ProvinciasByPais: [],
        provincias: [],
        // Punto de emision
        puntos_emision: [],
        // Impuestos
        impuestos: [],
        all_impuestos: [],
        // Impuesto
    },
    getters: {
        getCamposATSventas(state) {
            return state.camposATSventas
        },

        // getCamposATSventas(state) {
        //     return state.camposATSventas
        // },

        getVentanaControlError(state) {
            return state.controlErroresUsuario
        },
        getInformeEmpleados(state) {
            return state.informe
        },
        getDeducciones(state) {
            return state.deducciones
        },
        getCamposForm107Data(state) {
            return state.camposForm107
        },
        getCamposATS(state) {
            return state.camposATS
        },
        getProveedores(state) {
            return state.proveedor
        },
        getColaboradorExist(state) {
            return state.colaboradores
        },
        getIdentificaciones(state) {
            return state.identificaciones
        },
        getIVA(state) {
            return state.IVA_ATS
        },
        getICE(state) {
            return state.ICE_ATS
        },
        getRetIvaBienServ(state) {
            return state.RetIVA
        },
        getCamposImportacionesATS(state) {
            return state.camposImportATS
        },
        getFicha(state) {
            return state.ficha
        },
        getFichaXML(state) {
            return state.fichaXML
        },
        getVariables(state) {
            return state.variables
        },
        getImpuestoRenta(state) {
            return state.impuestoRenta
        },
        getDataA16470(state) {
            return state.a16470
        },
        getDivisionesData(state) {
            return state.divisionesUser
        },
        getDivisionesAll(state) {
            return state.divisionesAll
        },
        getDataExportExcel(state) {
            return state.exportExcel
        },
        getPorcentajesDiscapacidad(state) {
            return state.discapacidad
        },
        //get datos para el pdf
        getForm107(state) {
            return state.form107
        },
        getForm103(state) {
            return state.form103
        },
        getResumen103(state) {
            return state.resumen103
        },
        getDataA16475(state) {
            return state.a16475
        },
        getDataA16475_detalle(state) {
            return state.a16475_datos
        },
        getDataA16475Resum(state) {
            return state.resumido
        },
        getDataA16475ResumDiv(state) {
            return state.resumDiv
        },
        getDataA16475Detalle(state) {
            return state.a16475Detalle
        },
        getA16475Detalle_Tabla(state) {
            return state.a16475DetalleTabla
        },
        getDescargarFormato(state) {
            return state.descargaFormato
        },
        //RDEP SIN CALCULOS
        getDataA16475_detalle_SinCalc(state) {
            return state.a16475_datos_SinCalc
        },
        getDataA16475_detalle_SinCalcEx(state) {
            return state.a16475_datos_SinCalcEx
        },
        getForm107_SinCalc(state) {
            return state.form107_SinCalc
        },
        getA16475Detalle_Tabla_SinCalc(state) {
            return state.a16475DetalleTabla_SinCalc
        },
        getDataA16475Resum_SinCalc(state) {
            return state.resumido_SinCalc
        },
        getDataA16475ResumDiv_SinCalc(state) {
            return state.resumDiv_SinCalc
        },

        //ATS
        getCodigosRetenciones(state) {
            return state.codigosReten
        },
        getCodigosSustentos(state) {
            return state.codigos104_sustentos
        },

        getCodigosTransaccion(state) {
            return state.codigoTransaccion
        },

        getCodigoIdentificacion(state) {
            return state.CodigoIdentificacion
        },

        getRelacionTransaccionIdentificacion(state) {
            return state.RelacionTransaccionIdentificacion
        },

        getEliminarRelacionTransaccionIdentificacion(state) {
            return state.EliminarRelacionTransaccionIdentificacion
        },

        getDivisionesDataATS(state) {
            return state.divisionesUserATS
        },

        getDivisionesCS(state) {
            return state.divisionesUserCS
        },

        getProveedoresATS(state) {
            return state.proveedoresATS
        },

        getColaboradoresComprasATS(state) {
            return state.colaboradoresATS
        },

        //ventana Conceptos de Retencion en la fuente de impuesto a la renta (AIR)---------------------------
        getDatosConceptosAIR(state) {
            return state.DatosConceptosAIR
        },

        getEliminarConceptoRetencion(state) {
            return state.EliminarConceptoRetencion
        },

        //ventana Tipos de Comprobantes Autorizados ---------------------------------------------------------
        getTipoComprobante(state) {
            return state.TipoComprobante
        },

        getSustentoTributario(state) {
            return state.SustentoTributario
        },

        getRelacionComprobanteTransaccion(state) {
            return state.RelacionComprobanteTransaccion
        },

        getRelacionComprobanteSustento(state) {
            return state.RelacionComprobanteSustento
        },

        getDatosTipoComprobante(state) {
            return state.DatosTipoComprobante
        },

        //ventana CODIGO DE REGIMEN --------------------------------------------------------------------------
        getCodigosRegimen(state) {
            return state.CodigosRegimen
        },

        getEliminarCodigoRegimen(state) {
            return state.EliminarCodigoRegimen
        },

        //tonny
        getRuc(state) {
            return state.ruc
        },
        getDatosContribuyenteProv(state) {
            return state.datosContribuyenteProv
        },

        getUsuarios(state) {
            return state.Usuarios
        },

        getDivisionesGeneral(state) {
            return state.DivisionesGeneral
        },
        getCierreSRI(state) {
            return state.CierreSRI
        },
        //DG
        // getDivisionesCS(state) {
        //     return state.divisionesUserCS
        // },

        getReporteComprasServicios(state) {
            return state.reporteComprasServicios
        },

        getProvinciasByPais(state) {
            return state.ProvinciasByPais
        },
        getProvincias(state) {
            return state.provincias
        },

        //ronny
        getTipoPaises(state) {
            return state.tipoPaises
        },
        getPuntosEmision(state) {
            return state.puntos_emision
        },
        // Impuesto
        getImpuesto(state) {
            return state.impuestos
        },
        getAllImpuesto(state) {
            return state.all_impuestos
        },
        // Impuesto
    },
    mutations: {
        SET_CAMPOS_ATS_VENTAS(state, camposATSventas) {
            state.camposATSventas = camposATSventas
        },

        SET_CAMPOS(state, camposForm107) {
            state.camposForm107 = camposForm107
        },
        SET_CAMPOS_ATS(state, camposATS) {
            state.camposATS = camposATS
        },
        SET_CAMPOS_IMPORTACIONES_ATS(state, camposImportATS) {
            state.camposImportATS = camposImportATS
        },
        SET_PROVEEDORES(state, proveedor) {
            state.proveedor = proveedor
        },
        SET_COLAB_COMPRAS(state, colaboradores) {
            state.colaboradores = colaboradores //colaboradores encargados de hacer las compras
        },
        SET_IDENTIFICACIONES(state, identificaciones) {
            state.identificaciones = identificaciones
        },
        SET_IVA_ATS(state, IVA_ATS) {
            state.IVA_ATS = IVA_ATS
        },
        SET_ICE_ATS(state, ICE_ATS) {
            state.ICE_ATS = ICE_ATS
        },
        SET_RetIVA_ATS(state, RetIVA) {
            state.RetIVA = RetIVA
        },
        SET_CODIGOS_RETENCIONES(state, codigosReten) {
            state.codigosReten = codigosReten
        },
        SET_CODIGOS104_SUSTENTOS(state, codigos104_sustentos) {
            state.codigos104_sustentos = codigos104_sustentos
        },
        SET_FORM_107(state, form107) {
            state.form107 = form107
        },
        SET_FORM_103(state, form103) {
            state.form103 = form103
        },
        SET_RESUMEN_103(state, resumen103) {
            state.resumen103 = resumen103
        },
        SET_VARIABLES(state, variables) {
            state.variables = variables
        },
        SET_IR(state, impuestoRenta) {
            state.impuestoRenta = impuestoRenta
        },
        SET_A16470(state, a16470) {
            state.a16470 = a16470
        },
        SET_A16475(state, a16475) {
            state.a16475 = a16475
        },
        SET_A16475_detalle(state, a16475_datos) {
            state.a16475_datos = a16475_datos
        },
        SET_FICHA(state, ficha) {
            state.ficha = ficha
        },
        SET_FICHAXML(state, fichaXML) {
            state.fichaXML = fichaXML
        },
        SET_FICHACOMPLETA(state, ficha_completa) {
            state.ficha_completa = ficha_completa
        },
        SET_DISCAPACIDAD(state, discapacidad) {
            state.discapacidad = discapacidad
        },
        SET_EXCEL(state, exportExcel) {
            state.exportExcel = exportExcel
        },
        //getA06t5 para usuarios que tienen permisos a divisiones
        SET_A06t5(state, a06t5) {
            state.a06t5 = a06t5
        },
        //
        SET_DIVISIONES(state, divisionesUser) {
            state.divisionesUser = divisionesUser
        },
        SET_DIVISIONES_ALL(state, divisionesAll) {
            state.divisionesAll = divisionesAll
        },
        //getDeducciones para validar monto maximo en deducciones
        SET_DEDUCCIONES(state, deducciones) {
            state.deducciones = deducciones
        },
        SET_PAGES(state, current_page) {
            state.current_page = current_page
        },
        SET_TOTAL_PAGES(state, last_page) {
            state.last_page = last_page
        },
        SET_PER_PAGE(state, per_page) {
            state.per_page = per_page
        },
        SET_TOTAL(state, total) {
            state.total = total
        },
        SET_INFORME(state, informe) {
            state.informe = informe
        },
        SET_RESUMIDO(state, resumido) {
            state.resumido = resumido
        },
        SET_RESUMDIV(state, resumDiv) {
            state.resumDiv = resumDiv
        },
        SET_DETALLE(state, a16475Detalle) {
            state.a16475Detalle = a16475Detalle
        },
        SET_DETALLE_TABLA(state, a16475DetalleTabla) {
            state.a16475DetalleTabla = a16475DetalleTabla
        }, //NUEVO
        SET_DESCARGAFORMATO(state, descargaFormato) {
            state.descargaFormato = descargaFormato
        },

        SET_ESTADO_VARIABLE(state, registroId) {
            const detalle = state.variables.find(p => p.id === registroId)
            detalle.estado = 0
            //const indice = state.SRI.indexOf(detalle);
            //state.SRI.splice(indice,1);
        },

        SET_A16475_detalle_sinCalc(state, a16475_datos_SinCalc) {
            state.a16475_datos_SinCalc = a16475_datos_SinCalc
        },

        SET_A16475_detalle_sinCalcExiste(state, a16475_datos_SinCalcEx) {
            state.a16475_datos_SinCalcEx = a16475_datos_SinCalcEx
        },
        SET_TOTAL_sinCalc(state, total_SinCalc) {
            state.total_SinCalc = total_SinCalc
        },
        SET_FORM_107_SinCalc(state, form107_SinCalc) {
            state.form107_SinCalc = form107_SinCalc
        },
        SET_DETALLE_TABLA_SinCalc(state, a16475DetalleTabla_SinCalc) {
            state.a16475DetalleTabla_SinCalc = a16475DetalleTabla_SinCalc
        }, //NUEVO
        SET_RESUMIDO_SinCalc(state, resumido_SinCalc) {
            state.resumido_SinCalc = resumido_SinCalc
        },
        SET_RESUMDIV_SinCalc(state, resumDiv_SinCalc) {
            state.resumDiv_SinCalc = resumDiv_SinCalc
        },

        SET_CodigoTransaccion(state, codigoTransaccion) {
            state.codigoTransaccion = codigoTransaccion
        },

        SET_CodigoIdentificacion(state, CodigoIdentificacion) {
            state.CodigoIdentificacion = CodigoIdentificacion
        },

        SET_RelacionTransaccionIdentificacion(state, RelacionTransaccionIdentificacion) {
            state.RelacionTransaccionIdentificacion = RelacionTransaccionIdentificacion
        },

        SET_EliminarRelacionTransaccionIdentificacion(state, EliminarRelacionTransaccionIdentificacion) {
            state.EliminarRelacionTransaccionIdentificacion = EliminarRelacionTransaccionIdentificacion
        },

        //ventana Conceptos de Retencion en la fuente de impuesto a la renta (AIR)---------------------------
        SET_DatosConceptosAIR(state, DatosConceptosAIR) {
            state.DatosConceptosAIR = DatosConceptosAIR
        },

        SET_EliminarConceptoRetencion(state, EliminarConceptoRetencion) {
            state.EliminarConceptoRetencion = EliminarConceptoRetencion
        },

        //ventana Tipos de Comprobantes Autorizados ---------------------------------------------------------
        SET_TipoComprobante(state, TipoComprobante) {
            state.TipoComprobante = TipoComprobante
        },
        //RelacionComprobanteTransaccion
        SET_RelacionComprobanteTransaccion(state, RelacionComprobanteTransaccion) {
            state.RelacionComprobanteTransaccion = RelacionComprobanteTransaccion
        },

        //RelacionComprobanteSustento
        SET_RelacionComprobanteSustento(state, RelacionComprobanteSustento) {
            state.RelacionComprobanteSustento = RelacionComprobanteSustento
        },

        SET_SustentoTributario(state, SustentoTributario) {
            state.SustentoTributario = SustentoTributario
        },

        SET_DatosTipoComprobante(state, DatosTipoComprobante) {
            state.DatosTipoComprobante = DatosTipoComprobante
        },

        //ventana CODIGO DE REGIMEN --------------------------------------------------------------------
        SET_CodigosRegimen(state, CodigosRegimen) {
            state.CodigosRegimen = CodigosRegimen
        },

        SET_EliminarCodigoRegimen(state, EliminarCodigoRegimen) {
            state.EliminarCodigoRegimen = EliminarCodigoRegimen
        },

        setRuc(state, ruc) {
            state.ruc = ruc
        },
        setDatosContribuyenteProv(state, datosContribuyenteProv) {
            state.datosContribuyenteProv = datosContribuyenteProv
        },

        SET_DIVISIONESATS(state, divisionesUserATS) {
            state.divisionesUserATS = divisionesUserATS
        },

        SET_DIVISIONES_CS(state, divisionesUserCS) {
            state.divisionesUserCS = divisionesUserCS
        },

        SET_PROVEEDORESATS(state, proveedoresATS) {
            state.proveedoresATS = proveedoresATS
        },

        SET_COLABORADORESCOMPRASATS(state, colaboradoresATS) {
            state.colaboradoresATS = colaboradoresATS //colaboradores encargados de hacer las compras ATS
        },

        SET_USUARIOS(state, Usuarios) {
            state.Usuarios = Usuarios //colaboradores encargados de hacer las compras ATS
        },

        SET_DIVISIONESGENERAL(state, DivisionesGeneral) {
            state.DivisionesGeneral = DivisionesGeneral //divisiones generales
        },
        SET_ControlErrorUsuario(state, controlErroresUsuario) {
            state.controlErroresUsuario = controlErroresUsuario
        },
        // SET_DIVISIONES_CS(state, divisionesUserCS) {
        //     state.divisionesUserCS = divisionesUserCS
        // },

        SET_REPORTE_CS(state, reporteComprasServicios) {
            state.reporteComprasServicios = reporteComprasServicios
        },
        setTipoPaises(state, tipoPaises) {
            state.tipoPaises = tipoPaises
        },

        SET_CIERRESRI(state, CierreSRI) {
            state.CierreSRI = CierreSRI
        },
        // CRUD Punto Emision
        setPuntosEmision(state, puntos_emision) {
            state.puntos_emision = puntos_emision
        },

        SET_PROVINCIASBYPAIS(state, ProvinciasByPais) {
            state.ProvinciasByPais = ProvinciasByPais
        },
        SET_PROVINCIAS(state, provincias) {
            state.provincias = provincias
        },
        // Impuesto
        setImpuesto(state, impuestos) {
            state.impuestos = impuestos
        },
        setAllImpuesto(state, all_impuestos) {
            state.all_impuestos = all_impuestos
        },
        // Impuesto
    },
    actions: {
        postInfoEmpleado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/agregarInfoEmpl', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postA16475({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/agregarCalculosEmpl', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postA16475_detalle({ commit }, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/agregarCalculosEmpleados', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCamposForm107({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/camposForm107')
                    .then(response => {
                        commit('SET_CAMPOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchExcel({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/exportExcel')
                    .then(response => {
                        commit('SET_EXCEL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchFicha({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/Ficha')
                    .then(response => {
                        commit('SET_FICHA', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchFichaXML({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/FichaXML')
                    .then(response => {
                        commit('SET_FICHAXML', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchFichaCompleta({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/FichaCompleta')
                    .then(response => {
                        commit('SET_FICHACOMPLETA', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPorcentajesDiscapacidad({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/porcentajesDiscapacidad')
                    .then(response => {
                        commit('SET_DISCAPACIDAD', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDivisionesUser({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/divisionesUser')
                    .then(response => {
                        commit('SET_DIVISIONES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDivisionesAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/divisionesAll')
                    .then(response => {
                        commit('SET_DIVISIONES_ALL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchVariables({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/variables')
                    .then(response => {
                        commit('SET_VARIABLES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchImpuestoRenta({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/impuestoRenta')
                    .then(response => {
                        commit('SET_IR', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchA16470({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/a16470')
                    .then(response => {
                        commit('SET_A16470', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /*fetchA16475T({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get("/api/auth/tributacion", { params: data })
                    .then((response) => {
                        commit('SET_A16475', response.data.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },*/

        fetchA16475({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/a16475')
                    .then(response => {
                        commit('SET_A16475', response.data)
                        commit('SET_TOTAL', response.data.total)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //consultar nuevo A16475
        fetchA16475_detalle({ commit }, anio) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/a16475_detalle?anio=${anio}`)
                    .then(response => {
                        commit('SET_A16475_detalle', response.data)
                        commit('SET_TOTAL', response.data.total)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //tonny
        fetchGetRuc({ commit }, id_informante) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/parametrizaciones/validarRuc?id_informante=${id_informante}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setRuc', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroContribuyenteProv({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/registroContribuyenteProv', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetDatosContribuyenteProv({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/datosContribuyenteProv', { params: data })
                    .then(response => {
                        commit('setDatosContribuyenteProv', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchAnularContribuyenteProv({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/anularContribuyenteProv', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEditarContribuyenteProv({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/editarContribuyenteProv', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //consultar tabla detallada nueva
        fetchA16475Detalle_Tabla({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/resumDetalladoEmp?filtro=detallado`
                if (data.division) {
                    url += `&division=${data.division}`
                }
                if (data.periodo) {
                    url += `&periodo=${data.periodo}`
                }
                if (data.cedula) {
                    url += `&cedula=${data.cedula}`
                }
                if (data.nombres) {
                    url += `&nombres=${data.nombres}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_DETALLE_TABLA', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchA16475Detalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/resumDetallado?filtro="detalle"`
                if (data.division) {
                    url += `&division=${data.division}`
                }
                if (data.periodo) {
                    url += `&periodo=${data.periodo}`
                }
                if (data.cedula) {
                    url += `&cedula=${data.cedula}`
                }
                if (data.nombres) {
                    url += `&nombres=${data.nombres}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_DETALLE', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchA16475Resum({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/empleadosResum?seleccion=${data.seleccion}`
                url += `&division=${data.divisiones}`
                url += `&periodo=${data.periodo}`
                url += `&periodo_desde=${data.periodo_desde}`
                url += `&periodo_hasta=${data.periodo_hasta}`
                url += `&ApeInicio=${data.apellidos_desde}`
                url += `&ApeFin=${data.apellidos_hasta}`
                url += `&cedula=${data.cedula}`
                url += `&expReg=${data.expReg}`
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_RESUMIDO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //getA06t5 para usuarios que tienen permisos a divisiones
        fetchA06t5({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/a06t5')
                    .then(response => {
                        commit('SET_A06t5', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //getDeducciones para validar monto maximo en deducciones
        fetchDeducciones({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/deducciones')
                    .then(response => {
                        commit('SET_DEDUCCIONES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //getForm107 para armar el formulario 107 a exportar
        fetchForm107({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/empleadoForm107?division=${data.division}&anio=${data.aniosel}&cedula=${data.cedula}`
                if (data.periodo) {
                    url += `&periodo=${data.periodo}`
                }
                if (data.desde) {
                    url += `&periodo_desde=${data.desde}`
                }
                if (data.hasta) {
                    url += `&periodo_hasta=${data.hasta}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_FORM_107', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEmpleadoCompleto({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/empleadosInforme?division=${data.divisiones}`
                url += `&periodo=${data.periodo}`
                url += `&periodo_desde=${data.desde}`
                url += `&periodo_hasta=${data.hasta}`
                url += `&ApeInicio=${data.apellidos_desde}`
                url += `&ApeFin=${data.apellidos_hasta}`
                url += `&expReg=${data.expReg}`
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_INFORME', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchA16475ResumDiv({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/divisionResum?seleccion=${data.seleccion}`
                url += `&division=${data.divisiones}`
                url += `&periodo=${data.periodo}`
                url += `&periodo_desde=${data.periodo_desde}`
                url += `&periodo_hasta=${data.periodo_hasta}`
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_RESUMDIV', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDescargarFormato({ commit }) {
            return new Promise((resolve, reject) => {
                axios({ method: 'get', url: '/api/auth/tributacion/descargarFormat', responseType: 'blob' })
                    .then(response => {
                        commit('SET_DESCARGAFORMATO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Crear Variable
        crearVariable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/crearVariable', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarVariable({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/eliminarVariable', { registroId })
                    .then(response => {
                        commit('SET_ESTADO_VARIABLE', registroId)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchVariableId({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/editarVariable/${registroId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarRegistroVariable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/tributacion/editarRegistroVariable', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //configuracion de tabla porcentajde de discapacidad
        crearPorcDiscapacidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/crearPorcDiscapacidad', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDiscapId({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/editarPorcDiscap/${registroId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarPorcDiscapacidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/tributacion/editarPorcDiscap', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarPorcDiscap({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/eliminarPorcDiscap', { registroId })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //DEDUCCIONES
        fetchDeduccionId({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/editarPorcDeduc/${registroId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearDeduccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/crearDeduccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarDeduccion({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/eliminarDeduccion', { registroId })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarRegistroDeduccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/tributacion/editarPorcDeduccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //tabla impuesto a la renta
        crearImpuestoRenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/crearImpuestoRenta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //DEDUCCIONES
        fetchImpRentaId({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/editarImpRent/${registroId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarRegistroImpRent({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/tributacion/editarImpRent', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarImpRent({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/eliminarImpRent', { registroId })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //CAMPO EN FORMATO
        crearCampoFormato({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/crearCampoFormato', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCampoFormatoId({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/editarCampoFormat/${registroId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarCampoFormato({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/tributacion/editarCampoFormat', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarCampo({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/eliminarCampo', { registroId })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //TABLAS PARA GABINO- RDEP SIN REALIZACIÓN DE CÁLCULOS
        fetchA16475_detalle_sinCalculos({ commit }, anio) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/a16475_detalle_sinCalc?anio=${anio}`)
                    .then(response => {
                        commit('SET_A16475_detalle_sinCalc', response.data)
                        commit('SET_TOTAL_sinCalc', response.data.total)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchA16475_detalle_SinCalcExistente({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `/api/auth/tributacion/a16475_detalle_sinCalcExistente?periodo=${data.periodo}&division=${data.codigo_division}`
                    )
                    .then(response => {
                        commit('SET_A16475_detalle_sinCalcExiste', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postInfoEmpleado_SinCalc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/agregarInfoEmplSinCalc', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postA16475_detalle_SinCalc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/agregarCalculosEmpleados_SinCalc', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEmpleadoCompleto_SinCalc({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/empleadosInformeXML_SinCalc?division=${data.divisiones}`
                url += `&periodo=${data.periodo}`
                url += `&periodo_desde=${data.desde}`
                url += `&periodo_hasta=${data.hasta}`
                url += `&ApeInicio=${data.apellidos_desde}`
                url += `&ApeFin=${data.apellidos_hasta}`
                url += `&expReg=${data.expReg}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchForm107_SinCalc({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/empleadoForm107_SinCalc?division=${data.division}&anio=${data.aniosel}&cedula=${data.cedula}`
                if (data.periodo) {
                    url += `&periodo=${data.periodo}`
                }
                if (data.desde) {
                    url += `&periodo_desde=${data.desde}`
                }
                if (data.hasta) {
                    url += `&periodo_hasta=${data.hasta}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_FORM_107_SinCalc', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchA16475Detalle_Tabla_SinCalc({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/resumDetalladoEmp_SinCalc?filtro=detallado`
                if (data.division) {
                    url += `&division=${data.division}`
                }
                if (data.periodo) {
                    url += `&periodo=${data.periodo}`
                }
                if (data.cedula) {
                    url += `&cedula=${data.cedula}`
                }
                if (data.nombres) {
                    url += `&nombres=${data.nombres}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_DETALLE_TABLA_SinCalc', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchA16475Resum_SinCalc({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/empleadosResum_SinCalc?seleccion=${data.seleccion}`
                url += `&division=${data.divisiones}`
                url += `&periodo=${data.periodo}`
                url += `&periodo_desde=${data.periodo_desde}`
                url += `&periodo_hasta=${data.periodo_hasta}`
                url += `&ApeInicio=${data.apellidos_desde}`
                url += `&ApeFin=${data.apellidos_hasta}`
                url += `&cedula=${data.cedula}`
                url += `&expReg=${data.expReg}`
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_RESUMIDO_SinCalc', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchA16475ResumDiv_SinCalc({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/divisionResum_SinCalc?seleccion=${data.seleccion}`
                url += `&division=${data.divisiones}`
                url += `&periodo=${data.periodo}`
                url += `&periodo_desde=${data.periodo_desde}`
                url += `&periodo_hasta=${data.periodo_hasta}`
                url += `&expReg=${data.expReg}`
                axios
                    .get(url)
                    .then(response => {
                        commit('SET_RESUMDIV_SinCalc', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //getForm103 para armar el formulario 103 a exportar
        fetchForm103({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/Form103?division=${data.divisiones}&seleccion=${data.seleccion}&anio=${data.aniosel}&codigoSel=${data.calculo}`
                if (data.periodo) {
                    url += `&periodo=${data.periodo}`
                }
                if (data.periodo_desde) {
                    url += `&periodo_desde=${data.periodo_desde}`
                }
                if (data.periodo_hasta) {
                    url += `&periodo_hasta=${data.periodo_hasta}`
                }

                axios
                    .get(url)
                    .then(response => {
                        commit('SET_FORM_103', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchResumen103({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/Resumen103?division=${data.divisiones}&seleccion=${data.seleccion}&anio=${data.aniosel}&codigoSel=${data.calculo}`
                if (data.periodo) {
                    url += `&periodo=${data.periodo}`
                }
                if (data.periodo_desde) {
                    url += `&periodo_desde=${data.periodo_desde}`
                }
                if (data.periodo_hasta) {
                    url += `&periodo_hasta=${data.periodo_hasta}`
                }

                axios
                    .get(url)
                    .then(response => {
                        commit('SET_RESUMEN_103', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //ATS compras
        fetchCamposATS({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/camposATS')
                    .then(response => {
                        commit('SET_CAMPOS_ATS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCodigosRetenciones({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/codigos_retenciones')
                    .then(response => {
                        commit('SET_CODIGOS_RETENCIONES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRelacionSustentosForm104({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/rel_sustentos_codForm104')
                    .then(response => {
                        commit('SET_CODIGOS104_SUSTENTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchProveedores({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/proveedores')
                    .then(response => {
                        commit('SET_PROVEEDORES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchColaboradorExist({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/colaboradoresCompras')
                    .then(response => {
                        commit('SET_COLAB_COMPRAS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposIdentific({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/tiposIdentificacion')
                    .then(response => {
                        commit('SET_IDENTIFICACIONES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postComprasATS({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/agregarCompras', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //DG
        postVentasATS({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/agregarVentas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postComprasRetenciones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/agregarComprasRetenciones', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchIVA({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/variableIVA_ATS')
                    .then(response => {
                        commit('SET_IVA_ATS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchICE({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/variableICE_ATS')
                    .then(response => {
                        commit('SET_ICE_ATS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRetIvaBienServ({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/porc_RetIva_Bien_servicio')
                    .then(response => {
                        commit('SET_RetIVA_ATS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchComprasPeriodo({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/comprasPeriodo?periodo=${data.periodo}`
                url += `&division=${data.division}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchComprasPeriodoVentas({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/tributacion/comprasPeriodoVentas?periodo=${data.periodo}`
                url += `&division=${data.division}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //ATS IMPORTACIONES
        fetchCamposImportacionesATS({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/camposImportacionesATS')
                    .then(response => {
                        commit('SET_CAMPOS_IMPORTACIONES_ATS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //Ed
        fetchTipoFideicomiso({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/tiposFideicomisos')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //PARAMETRIZACIONES TRIBUTACION
        fetchCodigoTransaccion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/CodigoTransaccion')
                    .then(response => {
                        commit('SET_CodigoTransaccion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCreateTipoFideicomiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createTipoFideicomiso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateTipoFideicomiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updateTipoFideicomiso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCodigoIdentificacion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/CodigoIdentificacion')
                    .then(response => {
                        commit('SET_CodigoIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRelacionTransaccionIdentificacion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/RelacionTransaccionIdentificacion')
                    .then(response => {
                        commit('SET_RelacionTransaccionIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarRelacionTransaccionIdentificacion({ commit }, codigoRelacion) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/eliminarRelacionTransaccionIdentificacion', {
                        codigoRelacion,
                    })
                    .then(response => {
                        commit('SET_EliminarRelacionTransaccionIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTipoFideicomiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/removeTipoFideicomiso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // eliminarRelacionTransaccionIdentificacion({ commit }, codigoRelacion) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .post('/api/auth/tributacion/parametrizaciones/eliminarRelacionTransaccionIdentificacion', {
        //                 codigoRelacion,
        //             })
        //             .then(response => {
        //                 commit('SET_EliminarRelacionTransaccionIdentificacion', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        agregarRelacionTransaccionIdentificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/agregarRelacionTransaccionIdentificacion', data)
                    .then(response => {
                        //commit('SET_AGREGAR', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // //PARAMETRIZACIONES TRIBUTACION
        // fetchCodigoTransaccion({ commit }) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get('/api/auth/tributacion/parametrizaciones/CodigoTransaccion')
        //             .then(response => {
        //                 commit('SET_CodigoTransaccion', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        // fetchCodigoIdentificacion({ commit }) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get('/api/auth/tributacion/parametrizaciones/CodigoIdentificacion')
        //             .then(response => {
        //                 commit('SET_CodigoIdentificacion', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        // fetchRelacionTransaccionIdentificacion({ commit }) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get('/api/auth/tributacion/parametrizaciones/RelacionTransaccionIdentificacion')
        //             .then(response => {
        //                 commit('SET_RelacionTransaccionIdentificacion', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        // eliminarRelacionTransaccionIdentificacion({ commit }, codigoRelacion) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .post('/api/auth/tributacion/parametrizaciones/eliminarRelacionTransaccionIdentificacion', {
        //                 codigoRelacion,
        //             })
        //             .then(response => {
        //                 commit('SET_EliminarRelacionTransaccionIdentificacion', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        // //PARAMETRIZACIONES TRIBUTACION
        // fetchCodigoTransaccion({ commit }) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get('/api/auth/tributacion/parametrizaciones/CodigoTransaccion')
        //             .then(response => {
        //                 commit('SET_CodigoTransaccion', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        // fetchCodigoIdentificacion({ commit }) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get('/api/auth/tributacion/parametrizaciones/CodigoIdentificacion')
        //             .then(response => {
        //                 commit('SET_CodigoIdentificacion', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        // fetchRelacionTransaccionIdentificacion({ commit }) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get('/api/auth/tributacion/parametrizaciones/RelacionTransaccionIdentificacion')
        //             .then(response => {
        //                 commit('SET_RelacionTransaccionIdentificacion', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        // eliminarRelacionTransaccionIdentificacion({ commit }, codigoRelacion) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .post('/api/auth/tributacion/parametrizaciones/eliminarRelacionTransaccionIdentificacion', {
        //                 codigoRelacion,
        //             })
        //             .then(response => {
        //                 commit('SET_EliminarRelacionTransaccionIdentificacion', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        // agregarRelacionTransaccionIdentificacion({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .post('/api/auth/tributacion/parametrizaciones/agregarRelacionTransaccionIdentificacion', data)
        //             .then(response => {
        //                 //commit('SET_AGREGAR', data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        Modificarfechas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/Modificarfechas', data)
                    .then(response => {
                        //commit('SET_AGREGAR', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFormasPagoCobro({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/formasPagoCobro')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCodigoRelacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/parametrizaciones/CodigoRelacion/${data}`)
                    .then(response => {
                        //commit('SET_RelacionTransaccionIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateFormasPagoCobro({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createFormasPagoCobro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //ventana Conceptos de Retencion en la fuente de impuesto a la renta (AIR)-----------------------------
        //cargo datos para lectura
        fetchDatosConceptosAIR({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/DatosConceptosAIR')
                    .then(response => {
                        commit('SET_DatosConceptosAIR', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateFormasPagoCobro({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updateFormasPagoCobro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //agrego datos a la base de datos
        AgregarConceptoRetencion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/AgregarConceptoRetencion', data)
                    .then(response => {
                        //commit('SET_AGREGAR', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveFormasPagoCobro({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/removeFormasPagoCobro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //elimino un registro
        EliminarConceptoRetencion({ commit }, num_campo) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/EliminarConceptoRetencion', { num_campo })
                    .then(response => {
                        commit('SET_EliminarRelacionTransaccionIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoCombrante({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/tiposComprobante')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //modifico un registro en la base
        ModificarCodigoRetencion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/ModificarCodigoRetencion', data)
                    .then(response => {
                        //commit('SET_AGREGAR', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSutentoComprobante({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/sustentoComprobante')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //consulta de si existe un codigo de retención
        fetchConsultaCodigoRetencion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/parametrizaciones/CodigoRetencion/${data}`)
                    .then(response => {
                        //commit('SET_RelacionTransaccionIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateSutentoComprobante({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createSustentoComprobante', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //ventana Tipos de Comprobantes Autorizados (AIR)------------------------------------------------------
        //cargo datos para lectura
        fetchTipoComprobante({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/TipoComprobante')
                    .then(response => {
                        commit('SET_TipoComprobante', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateSutentoComprobante({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updateSustentoComprobante', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //cargo datos para llenar combobox de sustento tributario
        fetchSustentoTributario({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/SustentoTributario')
                    .then(response => {
                        commit('SET_SustentoTributario', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveSutentoComprobante({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/removeSustentoComprobante', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //lleno tabla del tab tipo de comprobante vs. Transacción
        fetchRelacionComprobanteTransaccion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/RelacionComprobanteTransaccion')
                    .then(response => {
                        commit('SET_RelacionComprobanteTransaccion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRetencionIVA({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/retencionIVA')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //lleno tabla del tab tipo de comprobante vs. Sustento Tributario
        fetchRelacionComprobanteSustento({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/RelacionComprobanteSustento')
                    .then(response => {
                        commit('SET_RelacionComprobanteSustento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateRetencionIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createRetencionIVA', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //agrego datos comprobantes vs. transaccion
        AgregarComprobanteTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/AgregarComprobanteTransaccion', data)
                    .then(response => {
                        //commit('SET_AGREGAR', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateRetencionIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updateRetencionIVA', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //agrego datos comprobantes vs sustento
        AgregarComprobanteSustento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/AgregarComprobanteSustento', data)
                    .then(response => {
                        //commit('SET_AGREGAR', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveRetencionIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/removeRetencionIVA', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //elimino un registro comprobante vs transaccion
        EliminarComprobanteTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/EliminarComprobanteTransaccion', data)
                    .then(response => {
                        //commit('SET_EliminarRelacionTransaccionIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSecuencialExportacion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/secuencialExportacion')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //elimino un registro comprobante vs sustentoTributario
        EliminarComprobanteSustento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/EliminarComprobanteSustento', data)
                    .then(response => {
                        //commit('SET_EliminarRelacionTransaccionIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateSecuencialExportacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createSecuencialExportacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //cargo datos para lectura
        fetchDatosTipoComprobante({ commit }, id_tipo_comprobante) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/DatosTipoComprobante', {
                        params: { id_tipo_comprobante },
                    })
                    .then(response => {
                        commit('SET_DatosTipoComprobante', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateSecuencialExportacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updateSecuencialExportacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //cargo datos para lectura
        fetchConsultaComprobanteTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/ConsultaComprobanteTransaccion', { params: data })
                    .then(response => {
                        //commit('SET_DatosTipoComprobante', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveSecuencialExportacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/removeSecuencialExportacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //cargo datos para lectura
        fetchConsultaComprobanteSustento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/ConsultaComprobanteSustento', { params: data })
                    .then(response => {
                        //commit('SET_DatosTipoComprobante', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //ventana Codigo Regimen --------------------------------------------------------------------------------
        //cargo datos a la tabla
        fetchCodigosRegimen({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/CodigosRegimen')
                    .then(response => {
                        commit('SET_CodigosRegimen', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //consulta de si existe un codigo de retención
        fetchConsultaCodigoRegimen({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/parametrizaciones/ConsultaCodigoRegimen/${data}`)
                    .then(response => {
                        //commit('SET_RelacionTransaccionIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //agrego datos a la base de datos
        AgregarCodigoRegimen({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/AgregarCodigoRegimen', data)
                    .then(response => {
                        //commit('SET_AGREGAR', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //elimino un registro
        EliminarCodigoRegimen({ commit }, co_regimen) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/EliminarCodigoRegimen', { co_regimen })
                    .then(response => {
                        commit('SET_EliminarRelacionTransaccionIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //modifico un registro en la base
        ModificarCodigoRegimen({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/parametrizaciones/ModificarCodigoRegimen', data)
                    .then(response => {
                        //commit('SET_AGREGAR', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //permisos de divisiones en ATS
        fetchDivisionesUserATS({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/divisionesUserATS')
                    .then(response => {
                        commit('SET_DIVISIONESATS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //DG
        /*fetchDivisionesCS({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/tributacion/divisionesUserCS')
                    .then((response) => {
                        commit('SET_DIVISIONES_CS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },*/

        //DG
        fetchDivisionesCS({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/divisionesUserCS')
                    .then(response => {
                        commit('SET_DIVISIONES_CS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //

        //

        fetchTipoPaises({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/tiposPaises')
                    .then(response => {
                        commit('setTipoPaises', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //carga de proveedores en ATS
        fetchProveedoresATS({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/proveedoresATS')
                    .then(response => {
                        commit('SET_PROVEEDORESATS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreatePais({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createPais', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchColaboradoresComprasATS({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/ColaboradoresComprasATS')
                    .then(response => {
                        commit('SET_COLABORADORESCOMPRASATS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatePais({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updatePais', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //obtenerr usuarios en general
        fetchUsuarios({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/parametrizaciones/Usuarios')
                    .then(response => {
                        commit('SET_USUARIOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemovePais({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/removePais', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //obtenerr divisiones en general
        fetchDivisionesGeneral({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/DivisionesGeneral')
                    .then(response => {
                        commit('SET_DIVISIONESGENERAL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //Distrito Aduanero
        fetchTipoDistritoAduanero({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/tiposDistritoAduanero')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateDistritoAduanero({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createDistritoAduanero', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateDistritoAduanero({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updateDistritoAduanero', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveDistritoAduanero({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/removeDistritoAduanero', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //Diego Control errores

        fetchCreateVentaControlErrores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createVentaControlError', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoCiudades({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/tiposCiudades', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCreateCiudades({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createCiudades', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateCiudades({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updateCiudades', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchVentaControlError({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/ventanaControl', { params: data })
                    .then(response => {
                        commit('SET_ControlErrorUsuario', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRemoveCiudades({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/removeCiudades', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoProvincias({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/tiposProvincias')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchcreateProvincias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/createProvincias', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchupdateProvincias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updateProvincias', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRemoveProvincias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/removeProvincias', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarPermisosVentanaTributacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/guardarPermisosVentana', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        cargarCopiarPermisosVentanaTributacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/guardarCopiarPermisosVentanaTributacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        //DG
        /*fetchDivisionesCS({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/tributacion/getDivisiones', data)
                    .the((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error)
                    })
            })
        },*/

        fetchcreateCierreSRI({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/tributacion/createCierreSRI', data).then(response => {
                    resolve(response)
                })
            })
        },

        fetchUpdateCierreSri({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/updateCierreSri', data)
                    .the(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReporteComprasServicios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/reporteComprasServicios', { params: data })
                    .then(response => {
                        commit('SET_REPORTE_CS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCamposATSventas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/camposATSventas')
                    .then(response => {
                        commit('SET_CAMPOS_ATS_VENTAS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchProvincias({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/tiposProvincias')
                    .then(response => {
                        commit('SET_PROVINCIAS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchProvinciasByPais({ commit }, idPais) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/tributacion/ProvinciasByPais/${idPais}`)
                    .then(response => {
                        commit('SET_PROVINCIASBYPAIS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        // CRUD Tipo Comprobante
        // fetchCreateTipoComprobante({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios.post('/api/auth/tributacion/createPais', data)
        //             .then((response) => {
        //                 resolve(response)
        //             })
        //             .catch((error) => {
        //                 reject(error);
        //             })
        //     })
        // },
        // fetchTipoComprobante({ commit }) {
        //     return new Promise((resolve, reject) => {
        //         axios.get('/api/auth/tributacion/tiposPaises')
        //             .then((response) => {
        //                 resolve(response)
        //             })
        //             .catch((error) => {
        //                 reject(error);
        //             })
        //     })
        // },
        // fetchUpdateTipoComprobante({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios.post('/api/auth/tributacion/updatePais', data)
        //             .then((response) => {
        //                 resolve(response)
        //             })
        //             .catch((error) => {
        //                 reject(error);
        //             })
        //     })
        // },
        // fetchRemoveTipoComprobante({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios.post('/api/auth/tributacion/removePais', data)
        //             .then((response) => {
        //                 resolve(response)
        //             })
        //             .catch((error) => {
        //                 reject(error);
        //             })
        //     })
        // },

        // CRUD Punto de Emision
        fetchCreatePuntoEmision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/configuracion/createPuntoEmision', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRetenciones({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/get_retenciones', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPuntosEmision({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/configuracion/readPuntosEmision')
                    .then(response => {
                        commit('setPuntosEmision', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatePuntoEmision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/configuracion/updatePuntoEmision', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDetalleRetencion({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/get_detalle_retencion', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDeletePuntoEmision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/configuracion/deletePuntoEmision', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPermisoDivision({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/get_permiso_division')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchNumeroRetencion({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/get_numero_retencion', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPermisoSerie({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/get_permiso_serie', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchProveedor({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/get_proveedor', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        enviarRetencion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/enviar_retencion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        validarRetencion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/validar_retencion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        enviarCorreo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/enviar_retencion_correo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        descargarRetencion({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/tributacion/descargar_retencion',
                    responseType: 'blob',
                    params,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        anularRetencion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/anular_retencion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        porcentajeFuente({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/get_porcentajes_fuente', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // Impuesto
        fetchImpuesto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/configuracion/getImpuesto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setImpuesto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAllImpuesto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/configuracion/getAllImpuesto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllImpuesto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateImpuesto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/configuracion/createImpuesto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateImpuesto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/configuracion/updateImpuesto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveImpuesto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/tributacion/configuracion/removeImpuesto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Impuesto

        categoriasxProveedor({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/get_categorias_x_proveedor', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        sustentosxCategoria({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/get_sustentos_x_categoria', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGuiaRemision({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/agregarVentas', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
    },
}
